import { catchError, concatMap, Observable, of, defer, mergeMap } from 'rxjs'
import {
  OrderActionTypes,
  UpdateOrderMetaDataGraphQLAction,
  UpdateOrderMetaDataGraphQLResult,
  UpdateOrderMetaDataGraphQLResultAction,
} from '../actions/order-actions'

import { handleError } from '@obeta/utils/lib/datadog.errors'
import { ofType } from 'redux-observable'
import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { UPDATE_ORDER_META_DATA_MUTATION } from '../entities/updateOrderMetaDataMutationProps'

export const updateOrderMetaDataGraphQLEffect = (
  apolloClient: ApolloClient<NormalizedCacheObject>
) => {
  return (actions$: Observable<UpdateOrderMetaDataGraphQLAction>) =>
    actions$.pipe(
      ofType(OrderActionTypes.UpdateOrderMetaDataGraphQL),
      concatMap((action: UpdateOrderMetaDataGraphQLAction) =>
        defer(async () => {
          const response = await apolloClient.mutate({
            mutation: UPDATE_ORDER_META_DATA_MUTATION,
            variables: {
              input: action.input,
            },
            fetchPolicy: 'no-cache',
          })
          return response.data?.updateOrderMetaData
        }).pipe(
          mergeMap((result: UpdateOrderMetaDataGraphQLResultAction) =>
            of(
              UpdateOrderMetaDataGraphQLResult(
                result.success,
                result.errorCode,
                result.errorMessage,
                result.orderId
              )
            )
          ),
          catchError((error) => {
            error.message =
              'error while processing ' +
              updateOrderMetaDataGraphQLEffect.name +
              ' ' +
              error.message
            handleError(error)
            return of(UpdateOrderMetaDataGraphQLResult(false, '', '', error))
          })
        )
      ),
      catchError((error) => {
        error.message = 'error in ' + updateOrderMetaDataGraphQLEffect.name + ' ' + error.message
        handleError(error)
        return of(UpdateOrderMetaDataGraphQLResult(false, '', '', error))
      })
    )
}

export const initAllOrderEpics = (apolloClient: ApolloClient<NormalizedCacheObject>) => {
  return [updateOrderMetaDataGraphQLEffect(apolloClient)]
}
